import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitobhimashankarcab() {



const cardData = {
  keyword: " Mumbai to Bhimashankar Cab ",

headingDescription: "Velocity Cab provides reliable and comfortable Mumbai to Bhimashankar cab services, ensuring a smooth and stress‑free journey to one of Maharashtra’s most revered Shiva pilgrimage sites and scenic hill stations. Our professional drivers, well‑maintained vehicles, and punctual pickups make traveling from Mumbai to Bhimashankar convenient and enjoyable. We offer flexible booking options including one‑way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air‑conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and groups. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for your Mumbai to Bhimashankar cab travel.",

topPlaces: [
  {
    title: "Bhimashankar Temple",
    description: "Bhimashankar Temple is a highly revered Hindu pilgrimage site dedicated to Lord Shiva and one of the 12 Jyotirlingas of India. Travelers from Mumbai can take a cab to this sacred temple set amidst lush forests and hills. Pilgrims can participate in traditional darshan, attend morning and evening aarti, and experience the serene spiritual atmosphere. The temple’s historic architecture and religious significance make it a major destination for devotees and spiritual seekers."
  },
  {
    title: "Bhimashankar Wildlife Sanctuary",
    description: "Bhimashankar Wildlife Sanctuary is a protected forest area surrounding the Bhimashankar region, known for its rich biodiversity and dense green cover. Travelers from Mumbai can visit the sanctuary after their cab journey to explore trekking trails, spot wildlife like the Indian giant squirrel, and enjoy nature walks among verdant flora and scenic landscapes. It’s a perfect destination for nature lovers and adventure enthusiasts."
  },
  {
    title: "Ahupe Waterfall",
    description: "Ahupe Waterfall is a stunning natural cascade located near Bhimashankar, offering a refreshing escape amid lush greenery. Travelers using a cab from Mumbai can enjoy a short trek to reach the waterfall, feel the cool mist, and relax by the scenic surroundings. It’s a popular spot for picnics, photography, and nature walks, especially during the monsoon season when the falls are at their most spectacular."
  },
  {
    title: "Naneghat Pass",
    description: "Naneghat Pass is a historic mountain pass that was once part of ancient trade routes through the Western Ghats. Cab travelers from Mumbai can visit this scenic spot to enjoy panoramic views of the surrounding valleys and hills. The pass also offers opportunities for trekking, photography, and exploring ancient stone inscriptions that reflect the region’s historical significance."
  },
  {
    title: "Bhorgiri Fort",
    description: "Bhorgiri Fort is a historic hilltop fort near Bhimashankar that offers breathtaking views of the surrounding Sahyadri mountains and lush valleys. Travelers from Mumbai can take a cab and then trek to the fort to explore its ruins, watchtowers, and stone structures. The trek route is surrounded by scenic natural beauty, making it popular with adventure lovers and history enthusiasts."
  },
  {
    title: "Kondeshwar Temple",
    description: "Kondeshwar Temple is another revered Hindu temple dedicated to Lord Shiva, located not far from Bhimashankar. Cab travelers from Mumbai can combine their pilgrimage with a visit to this serene temple set amidst verdant landscapes. The temple’s peaceful surroundings and spiritual atmosphere make it a meaningful stop for devotees and those seeking tranquility."
  },
  {
    title: "Savargaon Waterfall",
    description: "Savargaon Waterfall is a scenic waterfall located near Bhimashankar offering a refreshing retreat for visitors. Travelers from Mumbai can enjoy a leisurely walk through nature to reach the waterfall, relax by the cool waters, and capture photos of the picturesque scenery. It’s especially beautiful during the monsoon season when the surrounding hills are lush and green."
  },
  {
    title: "Kaas Plateau",
    description: "Kaas Plateau, also known as the 'Valley of Flowers,' is a UNESCO World Natural Heritage site near Bhimashankar. Travelers using a cab from Mumbai can visit this stunning plateau to witness colorful seasonal blooms, diverse flora, and breathtaking views of the Western Ghats. The plateau is a must‑visit spot for nature lovers and photographers."
  },
  {
    title: "Bhima River Source",
    description: "The Bhima River Source near Bhimashankar is considered sacred and is believed to be the origin of the Bhima River. Mumbai to Bhimashankar cab travelers can visit this serene spot to witness the river’s beginnings amidst lush greenery and tranquil surroundings. It’s a peaceful location for meditation, photography, and nature appreciation."
  },
  {
    title: "Chikhaldara Viewpoint",
    description: "Chikhaldara Viewpoint offers panoramic views of the Sahyadri ranges and surrounding valleys, making it a great stop for those traveling from Mumbai to Bhimashankar. Visitors can enjoy sweeping landscapes, lush hills, and refreshing breezes. The viewpoint is ideal for photography, nature walks, and spending peaceful moments in the lap of nature."
  }
],



services: [
{
name: "Mumbai to Bhimashankar Cab Service",
description: "Mumbai to Bhimashankar cab service offers a smooth and spiritual journey to one of the most sacred Jyotirlinga temples in Maharashtra. This service is ideal for devotees, families, and groups planning a comfortable darshan trip from Mumbai. The route passes through scenic ghats and forest areas, making the journey peaceful and refreshing. Professional drivers with experience in hill and ghat driving ensure a safe and reliable travel experience. Customers can choose from sedan, SUV, and premium vehicles based on their travel needs and group size. Flexible pickup options from home, airport, or railway station make the journey convenient. With transparent pricing, easy booking, and 24x7 availability, this cab service ensures a hassle-free and divine travel experience."
},
{
name: "Mumbai to Bhimashankar Taxi",
description: "Mumbai to Bhimashankar taxi service provides reliable and comfortable transportation for temple visits and short pilgrimages. Well-maintained vehicles and experienced drivers ensure a safe journey through hilly terrain and forest routes. This service is suitable for one day trips and weekend spiritual getaways. Travelers can enjoy door-to-door pickup and flexible travel timings. Multiple vehicle options are available for different budgets and group sizes. With affordable pricing and easy booking, this taxi service ensures a smooth and comfortable journey."
},
{
name: "One Way Cab Mumbai to Bhimashankar",
description: "One way cab Mumbai to Bhimashankar is a cost-effective option for travelers who need a single-side drop without return charges. This service is perfect for devotees planning onward travel or staying overnight near the temple. Customers benefit from competitive pricing, flexible pickup timing, and comfortable vehicles. Professional drivers ensure timely arrival and safe driving on ghat roads. Sedan and SUV options are available based on travel needs. Easy online booking and instant confirmation make it convenient for all travelers."
},
{
name: "Mumbai to Bhimashankar Cab Booking",
description: "Mumbai to Bhimashankar cab booking allows travelers to reserve their cab quickly with instant confirmation and flexible scheduling. Customers can choose vehicle types, travel dates, and pickup locations based on their preferences. Transparent pricing ensures no hidden costs during the journey. Online booking options make the process hassle-free and convenient. Dedicated support is available for assistance before and during the trip. It is the easiest way to plan your Bhimashankar darshan journey."
},
{
name: "Mumbai to Bhimashankar Outstation Taxi",
description: "Mumbai to Bhimashankar outstation taxi service offers comfortable long-distance travel with reliable vehicles and experienced drivers. This service is designed for pilgrims and tourists seeking a smooth and safe journey. Flexible pickup points and multiple travel options add convenience. Travelers can choose between one way and round trip packages. Vehicles are well-maintained for performance and safety on hilly roads. This service ensures a relaxed and enjoyable travel experience."
},
{
name: "Cheap Cab Mumbai to Bhimashankar",
description: "Cheap cab Mumbai to Bhimashankar provides budget-friendly travel options without compromising comfort and safety. This service is ideal for cost-conscious travelers looking for reliable transportation. Economical sedan options are available for lower fares. Transparent pricing ensures no hidden charges. Professional drivers ensure safe travel on ghat roads. It is a perfect balance of affordability and comfort."
},
{
name: "Mumbai to Bhimashankar Darshan Cab",
description: "Mumbai to Bhimashankar darshan cab service is specially designed for devotees visiting the Jyotirlinga temple. This service ensures timely temple visits, comfortable travel, and proper rest stops during the journey. Experienced drivers understand temple routes and schedules for smooth darshan planning. Flexible itineraries allow travelers to complete their visit peacefully. It is suitable for families and senior citizens. This service ensures a spiritual and comfortable experience."
},
{
name: "Private Taxi Mumbai to Bhimashankar",
description: "Private taxi Mumbai to Bhimashankar offers a personalized travel experience with exclusive vehicle usage. Travelers can customize their route, stops, and travel duration based on their preferences. This ensures a relaxed and stress-free journey. Professional drivers provide safe and reliable service throughout the trip. Comfortable seating and clean vehicles enhance the experience. It is ideal for families and private groups."
},
{
name: "AC Cab Mumbai to Bhimashankar",
description: "AC cab Mumbai to Bhimashankar ensures a comfortable journey in air-conditioned vehicles, especially during long-distance travel. This service provides a pleasant environment inside the vehicle regardless of weather conditions. Clean interiors and well-maintained AC systems enhance passenger comfort. Suitable for all types of travelers including families and corporate groups. Flexible pickup options add convenience. It ensures a relaxing travel experience."
},
{
name: "Mumbai to Bhimashankar SUV Taxi",
description: "Mumbai to Bhimashankar SUV taxi is ideal for group travel and those seeking extra comfort on hilly terrain. SUVs offer better road grip and spacious seating, making them perfect for this route. This option is suitable for families, friends, and corporate groups. Professional drivers ensure safe driving on challenging ghat roads. It provides a premium and comfortable travel experience. Ideal for long-distance and temple trips."
},
{
name: "Mumbai to Bhimashankar Cab Fare",
description: "Mumbai to Bhimashankar cab fare offers transparent and competitive pricing based on distance, vehicle type, and travel duration. Customers receive clear cost details including tolls and driver allowances where applicable. This helps travelers plan their budget effectively. Affordable options are available for sedan, SUV, and premium vehicles. No hidden charges ensure trust and reliability. It provides the best value for money for a spiritual journey."
}
],

tableData: [
["Mumbai to Bhimashankar Cab Service","Mumbai to Bhimashankar Taxi"],
["One Way Cab Mumbai to Bhimashankar","Mumbai to Bhimashankar Cab Booking"],
["Mumbai to Bhimashankar Outstation Taxi","Cheap Cab Mumbai to Bhimashankar"],
["Mumbai to Bhimashankar Darshan Cab","Private Taxi Mumbai to Bhimashankar"],
["AC Cab Mumbai to Bhimashankar","Mumbai to Bhimashankar SUV Taxi"],
["Mumbai to Bhimashankar Cab Fare","Mumbai to Bhimashankar Cab Service"]
],



whychoose: [
  {
    WhyChooseheading: "Comfortable Pilgrimage Travel",
    WhyChoosedescription: "Velocity Cabs offers reliable Mumbai to Bhimashankar cab service, perfect for devotees visiting the sacred Jyotirlinga temple with a smooth and peaceful travel experience."
  },
  {
    WhyChooseheading: "Experienced Ghat Route Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in ghat roads and forest routes leading to Bhimashankar, ensuring safe driving and comfortable navigation through hilly terrain."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs provides clear and transparent pricing for Mumbai to Bhimashankar cab bookings. Customers receive complete fare details including toll charges and driver allowance."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Mumbai to Bhimashankar cab service operates 24/7, allowing customers to plan early morning temple visits or late-night return journeys with ease."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well maintained, and regularly cleaned to ensure a comfortable and stress-free long-distance journey."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, same-day return, and multi-day round-trip packages for Bhimashankar darshan."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for individuals, families, and group pilgrimage travel."
  },
  {
    WhyChooseheading: "Trusted Pilgrimage Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many devotees for Mumbai to Bhimashankar cab bookings due to punctual drivers, comfortable vehicles, and reliable service."
  }
]
};

const faqData = [
  { question: "Do you provide Mumbai to Bhimashankar cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Mumbai to Bhimashankar for temple visits and pilgrimage travel." },
  { question: "How far is Bhimashankar from Mumbai?", answer: "The distance between Mumbai and Bhimashankar is approximately 210 km and the journey takes around 5 to 6 hours depending on the route." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Bhimashankar cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services from Mumbai to Bhimashankar." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Mumbai to Bhimashankar cabs online or through phone booking." },
  { question: "Do you provide pickup from home or hotel?", answer: "Yes, we provide doorstep pickup from homes, hotels, railway stations, and airports across Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended especially during weekends and festival seasons." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Kulkarni",
    feedback:
      "A peaceful and comfortable journey from Mumbai to Bhimashankar. The cab was well-maintained, and the drive through the route felt smooth and refreshing.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ritu Deshmukh",
    feedback:
      "The Mumbai to Bhimashankar cab service was very reliable. The vehicle was clean, the ride was steady, and the overall trip felt safe and well-organized.",
    rating: 5
  }
];




























const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];











const mumbaiBhimashankarJSON = {
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  "name": "Mumbai to Bhimashankar Cab | Velocity Cabs",
  "description": "Book a private cab from Mumbai to Bhimashankar for Darshan or outstation travel. AC, Sedan, and SUV taxis available for one-way or round trips.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Mumbai, Maharashtra, India"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Mumbai to Bhimashankar Cab Packages",
    "itemListElement": [
      {
        "@type": "Offer",
        "name": "One Way Cab from Mumbai to Bhimashankar",
        "description": "Private cab from Mumbai to Bhimashankar for one-way Darshan or trip with AC/SUV/Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      },
      {
        "@type": "Offer",
        "name": "Bhimashankar Outstation Cab from Mumbai",
        "description": "Comfortable cab service for round-trip or multi-day travel to Bhimashankar with private AC/SUV options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      }
    ]
  }
};






  return (
    <div>
      

<Helmet>
  <title>Mumbai to Bhimashankar Cab | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book a private cab from Mumbai to Bhimashankar for Darshan or outstation travel. AC, Sedan, and SUV taxis available for one-way or round trips."
  />
  <script type="application/ld+json">
    {JSON.stringify(mumbaiBhimashankarJSON)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/77.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitobhimashankarcab;